import React from 'react';
import PropTypes from 'prop-types';
import ErrorPage from '@src/components/ErrorPage';
import NotFoundIcon from '@src/components/common/icons/NotFoundIcon';
import useTranslation from '@src/hooks/useTranslation';

const NotMatchPage = ({ title, messages }) => {
	const { t } = useTranslation();

	return (
		<ErrorPage
			title={title || '404'}
			messages={messages || [
				t('common:message:page_not_found'),
				t('common:message:refresh_or_try_later'),
			]}
		>
			<NotFoundIcon />
		</ErrorPage>
	);
};

NotMatchPage.propTypes = {
	title: PropTypes.string,
	messages: PropTypes.arrayOf(PropTypes.string),
};

export default NotMatchPage;
